import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function ChatIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 32 32"
      style={{ fill: "transparent", ...(props.style || {}) }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 25H19.85H24.3H26V23.3V7.69999V5.99999H24.3H7.70005H6.00005V7.69999V23.3V25H7.70005H12.15H13L13.85 25.85L15.2929 27.2929C15.6835 27.6834 16.3166 27.6834 16.7072 27.2929L18.15 25.85L19 25ZM12.2959 26.7H6.00005C5.06116 26.7 4.30005 25.9389 4.30005 25V5.99999C4.30005 5.0611 5.06116 4.29999 6.00005 4.29999H26C26.9389 4.29999 27.7001 5.0611 27.7001 5.99999V25C27.7001 25.9389 26.9389 26.7 26 26.7H19.7042L17.9092 28.495C16.8548 29.5494 15.1453 29.5494 14.0909 28.495L12.2959 26.7Z"
        fill="currentColor"
      />
      <path
        d="M9 13C9 11.9643 9.89286 11 11 11C12.1071 11 13 11.8929 13 13"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12 18C12.6088 19.7514 14.1776 21 16.0117 21C17.8303 21 19.3834 19.6927 20 18"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19 13C19 11.9643 19.8929 11 21 11C22.1071 11 23 11.8929 23 13"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
